import { Action } from '@ngrx/store';

import { Permission } from './permission.model';

export const ADD_PERMISSION = '[Chat] Add Permissions';


export class AddPermission implements Action {
    readonly type = ADD_PERMISSION;

    constructor(public payload: Permission[] ) {}
}


export type PermissionActions =
| AddPermission;
